import { Receive } from "../common/Receive";
import { getTimestampInLocalTime } from "./dateUtil";
import { ModalAlertType } from "../components/Modal/ModalWithActionButton";

export const modals = {
	invalidEdiInvoiceNumber: {
		isOpen: true,
		primaryButtonName: "Ok",
		title: "Invalid invoice number",
	},
	clearReceive: {
		isOpen: true,
		paragraphs: ["Are you sure you want to clear out this receive?"],
		primaryButtonName: "Yes",
		secondaryButtonName: "No",
		title: "Clear Receive",
	},
	beginReview: {
		isOpen: true,
		paragraphs: ["Lock purchase order and begin review of submitted receives?"],
		primaryButtonName: "Begin review",
		secondaryButtonName: "Cancel",
		title: "Begin review",
	},
	finaliseRecieves: {
		isOpen: true,
		paragraphs: ["Are you ready to finalise all submitted receives?"],
		primaryButtonName: "Finalise",
		secondaryButtonName: "Cancel",
		title: "Finalise Receives",
	},
	saveChanges: {
		isOpen: true,
		paragraphs: ["Would you like to save changes? This will not finalise the receives."],
		primaryButtonName: "Save",
		secondaryButtonName: "Cancel",
		title: "Save changes",
	},
	editReceive: {
		isOpen: true,
		paragraphs: ["Would you like to edit this receive?"],
		primaryButtonName: "Edit",
		secondaryButtonName: "Cancel",
		title: "Edit receive",
	},
	saveDraft: {
		isOpen: true,
		paragraphs: ["Would you like to save and exit this receive? This will not submit the receive."],
		primaryButtonName: "Save",
		secondaryButtonName: "Cancel",
		title: "Save & Exit",
	},
	requestReview: {
		isOpen: true,
		paragraphs: ["Would you like to save your progress as a draft? This will not submit the receive."],
		primaryButtonName: "Save",
		secondaryButtonName: "Cancel",
		title: "Save draft",
	},
	finaliseSuccess: {
		isOpen: true,
		paragraphs: ["Receives finalised successfully"],
		primaryButtonName: "Ok",
		title: "Success",
		isSuccess: true,
	},
	reopenPurchaseOrderSuccess: {
		isOpen: true,
		paragraphs: [
			"Your request to reopen this purchase order is currently being processed and this may take few minutes. Meanwhile, if you would like to continue receiving other purchase order invoices then go back to search.",
		],
		primaryButtonName: "Return to home",
		title: "Reopen PO",
		isInfo: true,
	},
	reopenPurchaseOrderError: {
		isOpen: true,
		paragraphs: ["Purchase order failed to reopen. Please try re-opening it again!"],
		primaryButtonName: "Ok",
		title: "Error",
	},
	saveSuccess: {
		isOpen: true,
		paragraphs: ["Receive saved successfully."],
		primaryButtonName: "Ok",
		title: "Success",
		isSuccess: true,
	},
	submitSuccess: {
		isOpen: true,
		paragraphs: [
			"Receive successfully submitted for review. Make sure you have placed the supplier delivery paperwork in the appropriate tray.",
		],
		primaryButtonName: "Ok",
		title: "Success",
		isSuccess: true,
	},
	manualExplanation: {
		isOpen: true,
		paragraphs: [
			"This is a non-EDI purchase order, so you'll need to receive the supplier invoice manually. Start by entering the invoice number, invoiced date and delivered date as per the delivery paperwork. Once you complete this, you can start receiving by scanning the items' barcodes.",
			"Tip: If barcodes are missing, enter either the SKU or the model number.",
		],
		primaryButtonName: "Got it, let's scan",
		title: "Non-EDI Receive",
	},
	ediLikeAManualExplanation: {
		isOpen: true,
		paragraphs: [
			"There are no EDIs readily available for this purchase order, so start by entering the invoice number, invoiced date and delivered date as per the delivery paperwork.",
			"Once you complete this, you can start receiving by scanning the items' barcodes.",
			"Tip: If barcodes are missing, enter either the SKU or the model number.",
		],
		primaryButtonName: "Got it, let's scan",
		title: "EDI missing receive",
	},
	forcePartReceiveExplanation: {
		isOpen: true,
		paragraphs: [
			"The EDI Invoice available for this purchase order does not match the receive record/s found.",
			"If further deliveries are expected for this invoice, proceed to Part Receive the stock, ensuring the appropriate numerical suffix is applied to invoice number (eg '-1', '-2', etc).",
		],
		primaryButtonName: "Got it, let's scan",
		title: "EDI Mismatch",
	},
	genericError: {
		isOpen: true,
		paragraphs: ["There was an error. Please try again later"],
		primaryButtonName: "Return to home",
		title: "Error",
	},
	issueSaving: {
		isOpen: true,
		paragraphs: [
			"An error occurred while attempting to save, please try again or contact IT support if issue persists.",
		],
		primaryButtonName: "Ok",
		title: "Issue saving",
	},
	invoiceAlreadyUsed: {
		isOpen: true,
		primaryButtonName: "Ok",
		title: "Invalid invoice number",
	},
	issueRetrievingReceives: {
		isOpen: true,
		paragraphs: [
			"An issue occurred while retrieving receives, please try again or contact IT support if issue persists.",
		],
		primaryButtonName: "Ok",
		title: "Issue retrieving receives",
	},
	issueFinalisingReceive: {
		isOpen: true,
		paragraphs: [
			"An issue occurred while finalising receive, please try again or contact IT support if issue persists.",
		],
		primaryButtonName: "Ok",
		title: "Issue finalising receive",
	},
	cannotEditReviewingReceive: {
		isOpen: true,
		paragraphs: ["Cannot create receive for purchase order when review in progress."],
		primaryButtonName: "Ok",
		title: "Issue editing receive",
	},
	noReceivesForReview: {
		isOpen: true,
		paragraphs: ["There are no receives ready for review."],
		primaryButtonName: "Ok",
		title: "Issue starting review",
	},
	cannotFinaliseReceiveBeforeReview: {
		isOpen: true,
		paragraphs: ["Receives must be locked then reviewed before finalising."],
		primaryButtonName: "Ok",
		title: "Issue finalising receive",
	},
	ediLikeAManualSuccessfulFinalise: {
		isOpen: true,
		paragraphs: [
			"Your receive is now successfully submitted.",
			"Once the supplier sends the EDI, we will auto-match the invoice and finalise the receive in Shopkeeper.",
			"Be sure to put the delivery paperwork in the appropriate 'EDI received like a manual via app' tray.",
		],
		primaryButtonName: "Return to dashboard",
		title: "Success!",
		isSuccess: true,
		isExitable: true,
	},
	forcePartReceiveSuccessfulFinalise: {
		isOpen: true,
		paragraphs: [
			"Your receive is now successfully submitted.",
			"The items Part Received under this invoice reference number have now been received in Shopkeeper.",
			"Subsequent deliveries for this invoice can be received via this same method. Be sure to increment the invoice suffix ('-1', '-2', etc) for the next receive in WMS and the Receiving App.",
		],
		primaryButtonName: "Return to dashboard",
		title: "Success!",
		isSuccess: true,
		isExitable: true,
	},
	ediCheck: {
		isOpen: true,
		title: "Huzzah - EDI is now available!",
		paragraphs: [
			"We will convert this receive in to an EDI receive for you, and you can continue scanning the remainder items/qtys for this invoice and finalise the receive as per normal EDI receive process.",
		],
		primaryButtonName: "Continue EDI receive",
		isSuccess: true,
	},
	issueUnlockingPurchaseOrder: {
		isOpen: true,
		title: "Issue unlocking purchase order",
		paragraphs: ["An issue occurred while unlocking purchase order, however you can continue to read only."],
		primaryButtonName: "Ok",
	},
	issueValidatingLocationBay: {
		isOpen: true,
		title: "Issue scanning",
		paragraphs: [
			"Invalid Location. The location you have entered is invalid. Please enter the correct location to proceed",
		],
		primaryButtonName: "Ok",
	},
	outdatedEdiInvoiceCountData: {
		isOpen: true,
		title: "Hold up! This count data is out of date!",
		paragraphs: [
			"The existing count for this outstanding invoice started more than 12 hours ago. Check that the previously counted SOH is still correct before continuing.",
		],
		primaryButtonName: "Ok",
	},
	outstandingEdiInvoiceHasInProgressReceive: {
		isOpen: true,
		title: "This outstanding invoice has an in-progress Receive!",
		paragraphs: [
			"An in-progress Receive already exists matching this invoice. Please either continue with that Receive or clear it before starting your count.",
		],
		primaryButtonName: "Go to Receive",
		secondaryButtonName: "Clear existing Receive & begin count",
	},
	outstandingEdiInvoiceHasCompletedReceive: {
		isOpen: true,
		title: "This outstanding invoice has a Completed Receive!",
		paragraphs: [
			"A Completed Receive already exists matching this invoice. Please log this invoice with IT Support to investigate why it has not closed.",
		],
		primaryButtonName: "Ok",
	},
	outstandingEdiInvoiceHasInProgressUnknownTypeReceive: {
		isOpen: true,
		title: "This outstanding invoice has an unknown type Receive!",
		paragraphs: [
			"A Receive already exists matching this invoice with an undetermined type. Please clear this Receive before starting your count.",
		],
		primaryButtonName: "Clear Receive",
		secondaryButtonName: "Cancel",
	},
};

export const getCannotProcessEdiInvoiceModal = (skus: Array<string>) => {
	return {
		isOpen: true,
		primaryButtonName: "Ok",
		title: "Cannot process EDI invoice",
		paragraphs: skus?.length
			? [
					`Uh Oh, the supplier's EDI Invoice has the following items that are not on the purchase order. SKUs: ${skus.join(
						", "
					)}`,
					"Cannot process this receive in the app, please process in Shopkeeper directly.",
				]
			: [
					"Uh oh! Something went wrong while converting this receive in to an EDI receive. Contact IT support to resolve the issue.",
				],
	};
};

export const getPurchaseOrderLockedModal = (receive: Receive) => {
	return {
		isOpen: true,
		paragraphs: [
			`This purchase order has an active ${receive.status} receive and is locked by ${receive.modifiedBy} (${
				receive.modifiedById
			}) on ${getTimestampInLocalTime(receive.timestamp)}.`,
			"Would you like to unlock to edit?",
		],
		primaryButtonName: "No, open as read only",
		secondaryButtonName: "Yes, unlock to edit",
		title: "Purchase Order Locked",
	};
};

export type AlertModalState = {
	type?: ModalAlertType;
	title?: string;
	isOpen: boolean;
	message: string | string[];
};

export const DefaultAlertModalState: AlertModalState = {
	isOpen: false,
	message: "",
};
